export default __webpack_public_path__ + "static/media/eldoradoBg.adc986f6.svg";